import { ICoordinates, IOfferGeo } from 'shared/types/offers';

export const getGeoData = (geo?: IOfferGeo): ICoordinates | null =>
  geo && geo.coordinates && geo.coordinates.lat && geo.coordinates.lng
    ? { lat: geo.coordinates.lat, lng: geo.coordinates.lng }
    : null;
